import { IMLesson } from '../../types'
import { createNodeList } from '../../../nodeCreationHelpers'
import { parseLessonSynthesis } from './lessonSynthesis'
import { parseLessonAssessments } from '../assessment'
import { parseStudentLessonSummary } from './studentLessonSummary'
import { parseActivity } from './activity'

export default function parse(lesson: IMLesson) {
  if (!lesson.activities) return []
  return [
    createNodeList(
      {
        title: 'Activities',
      },
      [
        ...lesson.activities.map(parseActivity),
        ...parseLessonSynthesis(lesson),
        ...parseLessonAssessments(lesson),
        ...parseStudentLessonSummary(lesson),
      ],
    ),
  ]
}
